<template>
  <div id="profile-sidebar-parent">
    <vs-sidebar
      ref="sidebar"
      v-model="active"
      default-index="1"
      position-right
      color="primary"
      class="request-favs-offcanvas"
      spacer
      parent="#app"
      @input="onAction"
    >
      <div class="request-favs-offcanvas-row">
        <div class="request-favs-offcanvas-col favs">
          <h3>Favoriten</h3>
          <template v-if="matcherRequest">
            <table v-if="matcherRequest.favourites" class="user-matching-table">
              <tr v-for="(favourite, i) in matcherRequest.favourites" :key="i">
                <td
                  width="62"
                  class="table-progress"
                  @click="routeApplicant(favourite.id)"
                >
                  <radial-progress-bar
                    :diameter="40"
                    :completed-steps="applicantScores[favourite.id] * 100"
                    :total-steps="totalSteps"
                    :stroke-width="2"
                    :inner-stroke-width="2"
                    start-color="#89d549"
                    stop-color="#48c6f0"
                    inner-stroke-color="#ffffff"
                  >
                    <p class="progress-count">
                      {{
                        applicantScores[favourite.id] !== null ||
                        applicantScores[favourite.id] !== undefined
                          ? formatPercentage(applicantScores[favourite.id])
                          : "-"
                      }}
                    </p>
                  </radial-progress-bar>
                </td>
                <td @click="routeApplicant(favourite.id)">
                  <i class="far fa-user"></i>{{ favourite.firstName }}
                  {{ favourite.lastName }}
                </td>
                <td @click="routeApplicant(favourite.id)">
                  <i class="far fa-map-marker-alt"></i>
                  <template
                    v-if="
                      matcherRequest.favouritesAddresses &&
                        matcherRequest.favouritesAddresses[i]
                    "
                  >
                    {{ matcherRequest.favouritesAddresses[i].city }} </template
                  ><template v-else>
                    {{ applicantCities[favourite.id] }}
                  </template>
                </td>
                <td
                  class="match-action remove"
                  @click="removeApplicantFromFavourites(favourite.id)"
                >
                  <i class="fal fa-times"></i>
                </td>
              </tr>
            </table>

            <p v-else>Keine Favoriten ausgewählt</p>
          </template>
        </div>
        <div class="request-favs-offcanvas-col">
          <div class="vx-row mb-2">
            <h3 class="vx-col w-full">Vorschläge</h3>
            <DataInput
              v-model="orderBy"
              class="input-foreground vx-col w-full lg:w-1/2"
              type="select"
              name="orderBy"
              label="sortieren nach"
              :options="[
                { code: 'first_name', label: 'Nachname' },
                { code: 'last_name', label: 'Vorname' },
                { code: 'number', label: 'Nummer' },
                { code: 'updated_at', label: 'Zuletzt geändert' },
                { code: 'created_at', label: 'Neueste' },
                { code: 'original', label: 'Ähnlichkeit' }
              ]"
            />
            <!-- <DataInput
              v-model="desc"
              class="input-foreground"
              type="select"
              name="orderDescending"
              label="Auf/-Absteigend"
              :options="[
                { code: 'true', label: 'Absteigend' },
                { code: 'false', label: 'Aufsteigend' }
              ]"
            /> -->
            <DataInput
              v-model="desc"
              type="bool"
              name="isActive"
              label="Aufsteigend sortieren"
              class="vx-col w-full lg:w-1/2"
            />
          </div>
          <template v-if="matcherRequest">
            <table
              v-if="matchedApplicants && matchedApplicants.length"
              class="user-matching-table"
            >
              <tr v-for="(result, i) in matchedApplicants" :key="i">
                <template
                  v-if="
                    !matcherRequest.favourites
                      .map(x => x.id)
                      .includes(result.applicant.id)
                  "
                >
                  <td
                    width="62"
                    class="table-progress"
                    @click="routeApplicant(result.applicant.id)"
                  >
                    <radial-progress-bar
                      :diameter="40"
                      :completed-steps="result.similarity * 100"
                      :total-steps="totalSteps"
                      :stroke-width="2"
                      :inner-stroke-width="2"
                      start-color="#89d549"
                      stop-color="#48c6f0"
                      inner-stroke-color="#ffffff"
                    >
                      <p class="progress-count">
                        {{ formatPercentage(result.similarity) }}
                      </p>
                    </radial-progress-bar>
                  </td>
                  <td @click="routeApplicant(result.applicant.id)">
                    <i class="far fa-user"></i>{{ result.applicant.firstName }}
                    {{ result.applicant.lastName }}
                  </td>
                  <td @click="routeApplicant(result.applicant.id)">
                    <i class="far fa-map-marker-alt"></i>

                    <template
                      v-if="
                        result.applicant.contactData &&
                          result.applicant.contactData.address
                      "
                    >
                      {{ result.applicant.contactData.address.city }}
                    </template>
                  </td>
                  <td
                    class="match-action add"
                    @click="addApplicantToFavourites(result.applicant)"
                  >
                    <i class="far fa-check-circle"></i>
                  </td>
                </template>
              </tr>
            </table>
          </template>
        </div>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import gql from "graphql-tag";
import RadialProgressBar from "vue-radial-progress";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    RadialProgressBar,
    DataInput
  },
  data() {
    return {
      active: false,
      completedSteps: 67,
      totalSteps: 100,
      applicantCities: {},
      applicantScores: {},
      applicantSuggestions: [],
      orderBy: "original",
      desc: true,
      applicantAction: false
    };
  },
  apollo: {
    matcherRequest: {
      query: gql`
        query MatcherRequest($id: ID!) {
          matcherRequest(id: $id) {
            id
            title
            companyID
            companyContactPartnerID
            consultantID
            userID
            favourites {
              id
              firstName
              lastName
              occupationField {
                id
                name
              }
            }
            favouritesAddresses {
              city
            }
            vacancyTemplate {
              id
            }
            query {
              id
              fields {
                id
                name
                term {
                  id
                  queryType
                  numericValue
                  stringValue
                  minNumericValue
                  maxNumericValue
                }
              }
              fieldGroups {
                id
                name
                fields {
                  id
                  name
                  term {
                    id
                    queryType
                    numericValue
                    stringValue
                    minNumericValue
                    maxNumericValue
                  }
                }
              }
            }
          }
        }
      `,
      skip() {
        return !this.$route.params.previewid;
      },
      variables() {
        return {
          id: this.$route.params.previewid
        };
      },
      fetchPolicy: "no-cache"
    },
    matchApplicants: {
      //matching more than 1000 applicants seems unneccessary
      query: gql`
        query MatchAppplicants($input: MatcherRequestInput!) {
          matchApplicants(input: $input, size: 100, cutoff: 0.7) {
            page
            results {
              applicantId
              similarity
            }
          }
        }
      `,
      variables() {
        let input = Object.deleteIdsAndTypes(this.matcherRequest);
        delete input["favourites"];
        delete input["favouritesAddresses"];
        return {
          input
        };
      },
      skip() {
        return !this.matcherRequest;
      },
      update(data) {
        this.applicantSuggestions = data.matchApplicants.results;
        return data.matchApplicants;
      }
    },
    matchedApplicants: {
      query: gql`
        query FetchAndReorderApplicants(
          $applicantIds: [ID!]!
          $orderBy: String!
          $desc: Boolean
        ) {
          fetchAndReorderApplicants(
            applicantIds: $applicantIds
            orderBy: $orderBy
            desc: $desc
          ) {
            id
            firstName
            lastName
            contactData {
              address {
                city
              }
            }
            occupationField {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          orderBy: this.orderBy,
          desc: this.desc,
          applicantIds: this.applicantSuggestions.map(x => x.applicantId)
        };
      },
      update(data) {
        const applicants = data.fetchAndReorderApplicants;
        let mapping = {};
        for (const appl of this.applicantSuggestions) {
          mapping[appl.applicantId] = appl.similarity;
        }
        return applicants.map(appl => ({
          applicantId: appl.id,
          similarity: mapping[appl.id],
          applicant: appl
        }));
      }
    },
    scoreApplicants: {
      query: gql`
        query ScoreAppplicants(
          $input: MatcherRequestInput!
          $applicants: [ID!]!
        ) {
          scoreApplicants(input: $input, applicants: $applicants) {
            applicant {
              id
            }
            applicantAddress {
              city
            }
            similarity
          }
        }
      `,
      variables() {
        let input = Object.deleteIdsAndTypes(this.matcherRequest);
        delete input["favourites"];
        delete input["favouritesAddresses"];
        return {
          input,
          applicants: this.matcherRequest.favourites.map(x => x.id)
        };
      },
      update(data) {
        data = data.scoreApplicants;
        let newApplicantCities = {};
        let newApplicantScores = {};
        for (const qr of data) {
          newApplicantCities[qr.applicant.id] = qr.applicantAddress.city;
          newApplicantScores[qr.applicant.id] = qr.similarity;
        }
        this.applicantCities = newApplicantCities;
        this.applicantScores = newApplicantScores;
      },
      skip() {
        return !this.matcherRequest;
      }
    }
  },
  watch: {
    "$route.params.previewid": {
      handler(v) {
        if (v) {
          this.active = true;
        } else {
          this.active = false;
        }
      }
    }
  },
  async beforeDestroy() {
    document
      .querySelector(".request-favs-offcanvas .vs-sidebar--background")
      .removeEventListener("click", this.closeListener);
    const el = document.querySelector(".short-profile-popup");

    if (el) {
      el.remove();
    }
  },
  mounted() {
    let $this = this;
    this.closeListener = function() {
      $this.applicantAction = false;
      $this.onAction(false);
    };
    document
      .querySelector(".request-favs-offcanvas .vs-sidebar--background")
      .addEventListener("click", this.closeListener);
    if (this.$route.params.previewid) {
      this.$nextTick().then(() => {
        this.active = true;
      });
    }
  },
  methods: {
    formatPercentage(value) {
      if (!value) {
        return "-";
      }
      let result = value.toLocaleString("de-DE", {
        style: "percent",
        maximumFractionDigits: 0
      });
      result = result.replace(/\s+/, "");
      return result;
    },
    onAction(v) {
      if (!v) {
        if (this.applicantAction) {
          this.applicantAction = false;
          this.active = true;
        } else {
          this.$router.replace({
            name: this.$route.params.referer || "request.overview",
            params: {
              ...(this.$route.params.refererParams || {})
            }
          });
        }
      } else {
        console.log(v);
      }
    },
    routeApplicant(applicant) {
      this.active = false;
      setTimeout(() => {
        this.$router.push({
          name: "applicant.edit",
          params: {
            id: applicant
          }
        });
      }, 500);
    },
    addApplicantToFavourites(applicant) {
      this.applicantAction = true;
      const variables = {
        applicant: applicant.id,
        request: this.matcherRequest.id
      };
      this.$apollo.mutate({
        mutation: gql`
          mutation addApplicantToFavourites($request: ID!, $applicant: ID!) {
            addApplicantToFavourites(request: $request, applicant: $applicant) {
              id
            }
          }
        `,
        variables
      });
      if (!this.matcherRequest.favourites) this.matcherRequest.favourites = [];
      for (let a of this.matcherRequest.favourites) {
        if (a.id === applicant.id) {
          return;
        }
      }
      this.matcherRequest.favourites.push(applicant);
    },
    removeApplicantFromFavourites(applicant) {
      this.applicantAction = true;
      const variables = {
        applicant,
        request: this.matcherRequest.id
      };
      this.$apollo.mutate({
        mutation: gql`
          mutation RemoveApplicantFromFavourites(
            $request: ID!
            $applicant: ID!
          ) {
            removeApplicantFromFavourites(
              request: $request
              applicant: $applicant
            ) {
              id
            }
          }
        `,
        variables
      });
      for (let i = 0; i < this.matcherRequest.favourites.length; i++) {
        let f = this.matcherRequest.favourites[i];
        if (f.id == applicant) {
          this.matcherRequest.favourites.splice(i, 1);
          return;
        }
      }
    }
  }
};
</script>
<style>
.request-favs-offcanvas-col .vs__clear {
  display: none;
}
.vs__dropdown-menu {
  z-index: 50000 !important;
}
</style>
